module.exports = __webpack_public_path__ + "img/noneicon.b178293d.png";